<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start">
          <div class="mt-3 mr-3" style="min-width: 200px; ">
            <label class="vs-input--label">From</label>
            <div style="margin-bottom: 10px">
              <flat-pickr
                class="w-100"
                :config="{
                  ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i:s',
                  defaultDate: new Date().setHours(0, 0, 0),
                }"
                v-model="started_at_gt"
                @input="SetDatetimeForStart"
              />
            </div>
          </div>
          <div class="mt-3 mr-3" style="min-width: 200px">
            <label class="vs-input--label">To</label>
            <div style="margin-bottom: 10px">
              <flat-pickr
                class="w-100"
                :config="{
                ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i:s',
                  defaultDate: new Date().setHours(23, 59, 59),
                }"
                v-model="finished_at_lt"
                @input="SetDatetimeForEnd"
              />
            </div>
          </div>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <label class="vs-input--label"></label>
          <vs-button
            class="mt-3"
            @click="$router.push({ name: 'admin-reseller-add-manual-payment' })"
          >Add Manual Payment</vs-button>
         <!-- <vs-button
            class="mt-3 ml-3"
            @click="$router.push({ name: 'admin-reseller-add' })"
          >Add Reseller</vs-button>-->
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0">
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'

// Packages
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer components
import CellRendererActions from './cell-renderer/CellRendererActions'
import CellRendererStatus from './cell-renderer/CellRendererStatus'
import moment from 'moment';

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,
    flatPickr,
    //Cell Renderer components
    CellRendererActions,
    CellRendererStatus
  },
  data() {
    return {
      started_at_gt:  new Date().setHours(0, 0, 0),
      finished_at_lt:  new Date().setHours(23, 59, 59),
      // table header value
      columnDefs: [
        {
          headerName: 'Bulk UUID',
          field: 'bulk_uuid',
          minWidth: 360,
        },
        {
          headerName: 'Created On',
          field: 'started_at',
          minWidth: 230,
        },
        {
          headerName: 'Status',
          field: 'status',
          minWidth: 150,
        },
        {
          headerName: 'Count',
          field: 'dest_count',
          minWidth: 150,
        },
        {
          headerName: 'Sent',
          field: 'dest_sent',
          minWidth: 150,
        },
        {
          headerName: 'Failed',
          field: 'dest_failed',
          minWidth: 150,
        },
        {
          headerName: 'Success',
          field: 'dest_success',
          minWidth: 150,
        },
        {
          headerName: 'Rejected',
          field: 'route_status_rejected_count',
          minWidth: 150,
        },
        {
          headerName: 'Text',
          field: 'text',
          minWidth: 350,
        },
        {
          headerName: 'Action',
          flex: 0,
          cellRendererFramework: 'CellRendererActions',
          minWidth: 100,
        }
      ],

      // Cell Renderer components
      components: {
        CellRendererActions,
        CellRendererStatus
      }
    }
  },
  created(){
    this.GetList()
    this.SetDatetimeForEnd();
    this.SetDatetimeForStart()
  },
  methods: {
    SetDatetimeForEnd() {
      this.filters.finished_at_lt =  moment(this.finished_at_lt).format('MM-DD-YYYY')
      this.GetList()
    },
    SetDatetimeForStart() {
      this.filters.started_at_gt = moment(this.started_at_gt).format('MM-DD-YYYY')
      this.GetList()
    },
      GetList () {
        console.log(this.$store)
        this.$vs.loading()
        this.$store.dispatch('bulk/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 20,
        order_by: this.order_by || null,
        order_dir: this.order_dir || null,
      })
      .then(res => {
        this.list = res.items.map(this.TransformList)
        this.total = res.total
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
      },
      SearchWithField (e, field) {
      if (!e) delete this.filters[field]
      else this.filters[field] = e && e.value

      this.GetList()
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformList(item) {
      console.log(item)
      return {
        refreshData: this.GetList,
        bulk_uuid: item.bulk_uuid,
        started_at: format(new Date(item.started_at), 'yyyy:MM:dd HH:mm:ss'),
        status: item.status,
        dest_count: item.dest_count,
        dest_sent: item.dest_sent,
        dest_failed: item.dest_failed,
        dest_success: item.dest_success,
        route_status_rejected_count: item.route_status_rejected_count,
        text: item.text,
      }
    }
  },
}
</script>
<style scoped lang="scss">
  /*.ag-grid-table /deep/ .ag-overlay-no-rows-center{*/
  /*  margin-top: 18px!important;*/
  /*}*/
</style>
